import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { Colors } from '../../../shared/styles/StyleConst';

const CircleButton = ({
  onClick,
  icon,
  disabled,
}: {
  onClick: (e: any) => void;
  icon: IconDefinition;
  disabled: boolean;
}) => (
  <button
    type="button"
    className={`btn-circle ${disabled ? 'btn-circle--disabled' : ''}`}
    onClick={onClick}
  >
    <FontAwesomeIcon icon={icon} fixedWidth size="xs" />
    <style jsx>
      {`
        .btn-circle {
          background-color: #fff;
          background-position: center;
          background-repeat: no-repeat;
          background-size: 14px 14px;
          color: ${Colors.pjtBlue};
          border: solid 1px ${Colors.pjtBlue};
          border-radius: 50%;
          cursor: pointer;
          height: 32px;
          padding: 0 15px;
          -webkit-transition: all 0.1s ease;
          transition: all 0.1s ease;
          width: 30px;
          outline: 0;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .btn-circle--disabled {
          color: #ced4da;
          border: solid 1px #ced4da;
          cursor: default;
        }
      `}
    </style>
  </button>
);

export default CircleButton;
